import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { finalize, catchError } from "rxjs/operators";
import { AuthService } from '../services/auth.service';
import { HttpLoaderService } from '../services/http-loader.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private requestCounts = 0;

    constructor(
        private authService: AuthService,
        private httpLoaderService: HttpLoaderService,
        private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requestCounts++;
        this.httpLoaderService.show();
        const currentUser = this.authService.getCurrentUser();

        if (currentUser && currentUser.access_token) {
            if (!request.url.endsWith('/token')) {
                request = request.clone({
                    setHeaders: { Authorization: 'Bearer ' + currentUser.access_token }
                });
            }
        }
        return next.handle(request)
            .pipe(
                catchError(err => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401) {
                            if (this.router.url.startsWith('/admin')) {
                                this.router.navigate(['account/session-expired']);
                            } else {
                                this.router.navigate(['account/unauthorized']);
                            }
                        }
                    }
                    return throwError(err)
                }),
                finalize(() => {
                    this.requestCounts--;
                    if (this.requestCounts === 0) {
                        this.httpLoaderService.hide();
                    }
                })
            );
    }
}
